import { render, staticRenderFns } from "./mailcenter.vue?vue&type=template&id=6c4c4f20&scoped=true"
import script from "./mailcenter.vue?vue&type=script&lang=js"
export * from "./mailcenter.vue?vue&type=script&lang=js"
import style0 from "./mailcenter.vue?vue&type=style&index=0&id=6c4c4f20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c4f20",
  null
  
)

export default component.exports